import { useMemo } from 'react';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  useToggleModal,
} from '@sbv-clients/ui-shared';

import Main from './main';

const useCallOffsReportModal = (
  departmentId: number,
  positionId: number,
  date: Date
) => {
  const { open, openModal, closeModal } = useToggleModal();
  const modal = useMemo(
    () => (
      <Dialog open={open} fullWidth>
        <DialogHeader title="Call Offs Report" onClose={closeModal} />
        <DialogContent>
          <Main
            departmentId={departmentId}
            positionId={positionId}
            date={date}
          />
        </DialogContent>
      </Dialog>
    ),
    [open, closeModal, departmentId, positionId, date]
  );

  return {
    modal,
    openModal,
  };
};

export default useCallOffsReportModal;
